//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import uiShare from '@/component/uiShare'
import {
  isApp,
  isWeiXin,
  system,
  controlTopButton,
  shareFun,
  getQueryVariable,
  getUserInfo,
  savePhoto
} from '@/util/const'
import { createNamespacedHelpers } from 'vuex'
import { setAuthorization } from '../../axios/userInfo'

const { mapGetters } = createNamespacedHelpers('shangtang')
export default {
  components: {
    uiShare
  },
  data () {
    return {
      isApp: Boolean(isApp()),
      photo: ''
    }
  },
  mounted () {
    window.savePhoto = (obj) => {
      this.$toast({ mag: '保存成功', time: 500 })
    }
    window.getUserInfo = (obj) => {
      setAuthorization(obj.authorization)
      this.getPhotoIf()
    }
    if (isApp()) {
      getUserInfo({ callbackName: 'getUserInfo', needLogin: true })
    } else {
      setAuthorization('c1ec9237-8e01-4b7d-81c4-d596f6f9d47d')
      this.getPhotoIf()
    }
    if (Number(this.$route.params.new) === 0) {
      controlTopButton({
        right1text: '历史照片',
        right1link: `${window.location.origin}${window.location.pathname}#/shangtang/list`
      })
    }
  },
  methods: {
    ...mapGetters(['getPhoto']),
    getPhotoIf () {
      if (Number(this.$route.params.new) === 0) {
        this.getLatestPhoto()
      } else {
        this.photo = getQueryVariable('photo')
        if (!this.photo) {
          this.photo = this.getPhoto()
        }
      }
    },
    shareFun () {
      let _href = `${location.origin}${location.pathname}#/shangtang/detail/1?photo=${this.photo}`
      location.href = `cmcchkhsh://openshare?url=${encodeURI(_href)}&title=大屏&img=${this.photo}&content=大屏`
    },
    test () {
      console.log('test')
    },
    downloadPhoto () {
      savePhoto({ imgUrl: this.photo, callback: 'savePhoto' })
    },
    getLatestPhoto () {
      this.$http.get('/v1/api/user/largescreen/none/getLargeScreenLastPhoto').then(res => {
        this.photo = res.data.body.photo[0]
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/shangtang/detail.vue